/**
 * Model configurations, fetched independently of whichever card asks for them — same
 * reasoning as `areasProjects.ts`: `ModelConfigsCard` and `ModelSlotsCard` both need the
 * list (the second one for its slot pickers), and two independent fetches of a small list
 * costs nothing a solo user would notice.
 */

import { useCallback, useEffect, useState } from "react";
import { ApiError, api, type ModelConfig } from "./api";

export function useModelConfigs(refreshKey?: number) {
  const [configs, setConfigs] = useState<ModelConfig[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setConfigs((await api.modelConfigs()).configs);
      setError(null);
    } catch (err) {
      if (err instanceof ApiError && err.isAuth) return;
      setError(err instanceof Error ? err.message : String(err));
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load, refreshKey]);

  return { configs, error, reload: load };
}
